<template>
	<section>
		<img
			v-if="!replaceimg"
			@click="replaceThumbnail"
			class="pointer"
			src="@/assets/candidates/replace-blue.svg"
			alt=""
		/>
		<img
			:class="{
				'opacity-img ': progress > 0 || uploadProgress > 0,
			}"
			v-else
			@click="handleProgressClick"
			src="@/assets/asset-bank/listview/img-replace.svg"
			alt=""
		/>
		<input
			ref="replace"
			type="file"
			:accept="fileTypes"
			class="d-none pointer"
			@change="fileSelected"
		/>
	</section>
</template>

<script>
import selectFile from "@/mixins/selectFile";
export default {
	name: "ReplaceFile",
	props: {
		replaceimg: {
			type: Boolean,
			default: false,
		},
		progress: Number,
		uploadProgress: Number,
	},
	mixins: [selectFile],
	methods: {
		handleProgressClick() {
			if (
				(this.progress === 0 && this.uploadProgress === undefined) ||
				(this.progress === 0 && this.uploadProgress === 0)
			) {
				this.replaceThumbnail();
			}
		},
		fileSelected(event) {
			if (this.fileTypes.includes("xlsx") || this.fileTypes.includes("xls")) {
				this.uploadExcelFile(event.target.files[0]);
			} else {
				this.uploadFile(event.target.files[0]);
			}
		},
		replaceThumbnail() {
			this.$refs.replace.click();
		},
	},
};
</script>
<style>
.opacity-img {
	opacity: 50%;
}
</style>
